export default "__VITE_ASSET__BabXOJ$o__"